import { SlidersHorizontalIcon, XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import SearchFilters, { SearchFiltersProps } from "./SearchFilters";
import { Button } from "../ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { motion, AnimatePresence } from "framer-motion";

export default function FiltersDialogButton(props: SearchFiltersProps) {
  const t = useTranslation();
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  useEffect(() => {
    if (isFiltersOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none"; // iOS scroll lock
    } else {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    };
  }, [isFiltersOpen]);

  return (
    <>
      <Button
        variant="default"
        className="flex flex-row gap-3 lg:hidden rounded-xl z-10"
        onClick={() => setIsFiltersOpen(true)}
      >
        <SlidersHorizontalIcon className="h-5 w-5" />
        {t.SEARCH_PAGE.LABELS.SEARCH_BUTTON}
      </Button>

      <AnimatePresence>
        {isFiltersOpen && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            onClick={() => setIsFiltersOpen(false)}
          >
            <motion.div
              className="w-full max-w-md max-h-[85vh] border border-zinc-800 overflow-y-auto rounded-3xl bg-background text-white"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.15 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between mb-6 px-6 pt-6">
                <h2 className="text-xl font-semibold">
                  {t.SEARCH_PAGE.LABELS.TITLE}
                </h2>
                <button
                  onClick={() => setIsFiltersOpen(false)}
                  className="w-7 h-7 p-0 focus:outline-none text-center"
                >
                  <XIcon className="h-7 w-7 text-zinc-400" />
                </button>
              </div>
              <SearchFilters
                {...props}
                setFiltersModalOpen={setIsFiltersOpen}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
